<div class="flex-container">
  <h4>Custom Announcements</h4>
  <div class="ml-auto">
    @if (!autoPlayAll && queuePeriodicAnnouncementItems.length > 0) {
      <button
        mat-raised-button
        type="button"
        class="queue-periodic-announcement-play-audio-button"
        (click)="onPlayAllClick()"
        >
        <mat-icon>play_arrow</mat-icon> {{ queuePeriodicAnnouncementItems.length === 1 ? 'Play' : 'Play All' }}
      </button>
    }
    @if (autoPlayAll && queuePeriodicAnnouncementItems.length > 0) {
      <button
        mat-raised-button
        type="button"
        class="queue-periodic-announcement-play-audio-button"
        (click)="onStopAllClick()"
        >
        <mat-icon>stop</mat-icon> Stop
      </button>
    }
    <button type="button" mat-raised-button [matMenuTriggerFor]="createPromptMenu">Add Prompt</button>
  </div>
</div>

<mat-menu #createPromptMenu>
  @if (this.extensionPrivileges?.canEditOthers) {
    <button
      type="button"
      mat-menu-item
      (click)="onAddExistingPromptClick()"
      >Add Existing Prompts to Extension</button
      >
    }
    @if (this.extensionPrivileges?.canEditOthers) {
      <button
        type="button"
        mat-menu-item
        (click)="onAddNewPromptClick(promptTypes.PeriodicAnnouncement)"
        >Add New Prompts to Extension</button
        >
      }
    </mat-menu>
    <ul cdkDropList (cdkDropListDropped)="drop($event)" class="announcement-item-list">
      @for (promptItem of queuePeriodicAnnouncementItems; track promptItem; let promptArrayIndex = $index) {
        <li
          cdkDrag
          [cdkDragDisabled]="isPaused == false || isLoading"
          (dblclick)="onPlayClick(promptArrayIndex, $event)"
          >
          @if (!promptItem.isDeleted) {
            <div class="announcement-item">
              <mat-icon class="draggable" aria-label="reorder drag handle" cdkDragHandle>drag_indicator</mat-icon>
              <span class="item-text">{{ promptItem.prompt.name }}</span>
              <div class="announcement-actions">
                @if (promptArrayIndex === currentPlaylistIndex && isLoading == false && showError == false) {
                  <span
                    class="queue-periodic-announcement-now-playing"
                    >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="queue-periodic-announcement-equalizer"
                      viewBox="0 0 128 128"
                      >
                      <g>
                        @for (index of [0, 1, 2, 3, 4]; track index) {
                          <ng-container>
                            <rect
                           [ngClass]="
                              isPaused
                                 ? 'queue-periodic-announcement-bar-paused'
                                 : 'queue-periodic-announcement-bar-playing'
                           "
                              [attr.transform]="'translate(' + index * 20 + ',0)'"
                              y="15"
                            ></rect>
                          </ng-container>
                        }
                      </g>
                    </svg>
                  </span>
                }
                @if (isLoading && promptArrayIndex === currentPlaylistIndex && showError == false) {
                  <div
                    class="announcement-spinner-container"
                    >
                    <mat-spinner class="queue-periodic-announcement-spinner" [diameter]="20"></mat-spinner>
                  </div>
                }
                @if (showError && promptArrayIndex === currentPlaylistIndex) {
                  <div
                    class="announcement-error-container"
                    matTooltip="Error playing prompt."
                    >
                    <mat-icon style="color: red"> error_outline </mat-icon>
                  </div>
                }
                <button
                  type="button"
                  aria-label="Play/Pause the Selected Prompt"
                  matTooltip="{{ promptArrayIndex === currentPlaylistIndex && isPaused === false ? 'Pause' : 'Play' }}"
                  mat-icon-button
                  [disabled]="disabled"
                  (click)="onPlayClick(promptArrayIndex)"
                  id="queue-periodic-announcement-play-prompt-{{ promptArrayIndex }}"
                  >
                  <mat-icon>
                    {{ promptArrayIndex === currentPlaylistIndex && isPaused === false ? 'pause' : 'play_arrow' }}
                  </mat-icon>
                </button>
                <button
                  type="button"
                  aria-label="Queue Periodic Announcement Actions"
                  matTooltip="More Actions"
                  mat-icon-button
                  [matMenuTriggerFor]="queuePeriodicAnnouncementListItemMenu"
                  [matMenuTriggerData]="{ $implicit: promptItem, index: promptArrayIndex }"
                  [disabled]="disabled"
                  id="queue-periodic-announcement-list-option-menu-button-{{ promptArrayIndex }}"
                  >
                  <mat-icon> more_vert </mat-icon>
                </button>
              </div>
            </div>
          }
        </li>
      }
      @if (!queuePeriodicAnnouncementItems || queuePeriodicAnnouncementItems.length === 0) {
        <span
          >No Announcements Set</span
          >
        }
      </ul>
      @if (showAudioPlayer) {
        <ndt-audio-playlist-player
          class="queue-periodic-announcement-playlist-player"
          [disabled]="disabled"
          [fileTokens]="fileTokens"
          [autostart]="false"
          >
        </ndt-audio-playlist-player>
      }
      <mat-menu #queuePeriodicAnnouncementListItemMenu="matMenu">
        <ng-template matMenuContent let-promptlistItem let-index="index">
          <button type="button" mat-menu-item id="queue-periodic-announcement-list-option-edit-button-download"
            ><a
            [attr.download]="promptlistItem.prompt.name"
            [attr.href]="promptlistItem.prompt.file?.fileToken | fileUrl"
            class="text-primary"
            >Download</a
            >
          </button>
          @if (this.extensionPrivileges?.canEditOthers) {
            <button
              type="button"
              mat-menu-item
              id="queue-periodic-announcement-list-option-edit-button-delete"
              (click)="onDeleteClick(index)"
              >
              Delete
            </button>
          }
          <button type="button" mat-menu-item id="mailbox-message-register-option-play" (click)="onPlayClick(index)">
            {{ index === currentPlaylistIndex && isPaused === false ? 'Pause' : 'Play' }}
          </button>
        </ng-template>
      </mat-menu>
